<template>
  <transition name="reveal">
    <div
      v-if="active"
      class="entry__bottom"
    >
      <div class="close">
        <close-icon :fill="closeColor"/>
      </div>

      <slot></slot>

    </div>
  </transition>
</template>


<script>
import CloseIcon from '@/components/icons/icon-close.vue'

export default {
  name: 'item-bottom',
  props: {
    active: {
      type: Boolean,
      default () {
        return false
      },
    },
  },
  components: {
    CloseIcon,
  },
  data () {
    return {
      popupHeader: {},
      popupBody: {},
    }
  },
  methods: {
    close () {
      this.$emit('bottomHeight', 0)
    },
  },
  updated () {
    this.$nextTick(() => {
      setTimeout(() => {
        if (this.active) {
          this.$emit('bottomHeight', this.$el.offsetHeight)
          // this.$el.scrollIntoView({ behavior: 'smooth' })
        }
      }, 0)
    })
  },
  computed: {
    closeColor () {
      return (this.$root.content.options &&this.$root.content.options.theme) === 'dark'
        ? '#fff'
        : '#333'
    }
  },

  mounted () {
    this.$nextTick(() => {})
  }
}
</script>


<style scoped lang="sass">
@import index

.reveal
  &-enter-active
    transition: opacity 200ms, transform 400ms
    opacity: 1
    transform: scale(1)
  &-leave-active
    transition: opacity 200ms, transform 400ms
    opacity: 1
    transform: scale(1)
  &-enter
    transform: scale(0.6)
    opacity: 0
  &-leave-to
    transform: scale(0.6)
    opacity: 0

.entry
  &__bottom
    cursor: pointer
    position: absolute
    width: 100%
    left: 0
    border-radius: 8px
    transform-origin: top
    z-index: 100
    padding: 0 2px

.close
  position: absolute
  top: 10px
  right: 10px
  transform: scale(0.6)
  z-index: 999

.content
  flex-wrap: wrap
  padding: 0
  margin: 0

  &__header
    padding: 20px
  &__body
    margin: 0
    padding: 20px





h5, h4
  margin: 0
  text-transform: uppercase
  span
    font-weight: 800
    margin-right: 16px
    &.dot
      display: inline-block
      width: 12px
      height: 12px
      border-radius: 24px
      vertical-align: middle
      margin-right: 8px
      margin-bottom: 4px
  &:last-of-type
    margin-bottom: 0
  &:first-letter
    text-transform: uppercase



</style>



// WEBPACK FOOTER //
// src/components/expanding-grid/item-bottom-slot.vue